import { Analytics } from '@cobliteam/analytics';
import Button from '@cobliteam/ui/components/Button';
import Tooltip from '@cobliteam/ui/components/Tooltip';
import { SelectVirtualized } from '@cobliteam/ui/form/Select';
import Icon from '@cobliteam/ui/icons';
import { formatDateTZ } from '@cobliteam/utils/date';
import { type ThreadSelectOption, useAIAssistant } from '../store';

const THREAD_SELECT_OPTIONS_HEIGHT = 32;
const THREAD_SELECT_OPTIONS_WIDTH = 324;

const AIAssistantThreadSelectionOptions = ({ option, selectedThreadId }: { option: ThreadSelectOption; selectedThreadId?: string }) => {
  return (
    <div className='flex items-center'>
      <Tooltip content={formatDateTZ(option.createdAt, 'dd/MM/yyyy HH:mm:ss')} asChild>
        <div className='flex items-center'>
          {selectedThreadId !== '' && <div className='w-4'>{option.value === selectedThreadId && <Icon name='check' className='h-4 w-4 text-gray-10' />}</div>}
          <div className='flex flex-col'>
            <span className='line-clamp-1 text-gray-12'>{option.label}</span>
          </div>
        </div>
      </Tooltip>
    </div>
  );
};

export const AIAssistantThreadSelection = () => {
  const { threadsOptions, isLoadingThreads, threadId, setThreadId, resetNewThreadId } = useAIAssistant();

  const handleThreadChange = (option: ThreadSelectOption | undefined) => {
    if (option) {
      Analytics.track('AI - Chat - New Conversation Created', { threadId: option.value, source: 'sidepanel' });
      setThreadId(option.value);
      resetNewThreadId();
    } else {
      setThreadId('');
      resetNewThreadId();
    }
  };

  return (
    <SelectVirtualized
      placeholder='Selecionar o thread'
      options={threadsOptions ?? []}
      optionHeight={THREAD_SELECT_OPTIONS_HEIGHT}
      portal={false}
      value={threadsOptions?.find((option) => option.value === threadId)}
      selectItem={({ option }) => <AIAssistantThreadSelectionOptions option={option} selectedThreadId={threadId} />}
      onValueChange={handleThreadChange}
      width={THREAD_SELECT_OPTIONS_WIDTH}
      className='space-y-2'
      popoverWidth={THREAD_SELECT_OPTIONS_WIDTH}
    >
      <Button disabled={isLoadingThreads} variant='ghost' size='sm' icon={<Icon name={isLoadingThreads ? 'loader' : 'history'} className='h-4 w-4' />} className='h-8 w-8 p-0' />
    </SelectVirtualized>
  );
};
